// extracted by mini-css-extract-plugin
export default {"room_wrap":"style_room_wrap__Og-G6","room_left_wrap":"style_room_left_wrap__AFsRo","room_center_wrap":"style_room_center_wrap__ge3Ym"};